"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListCountriesDDI = void 0;
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
const react_1 = __importDefault(require("react"));
const ListCountriesDDI = ({ items, value, listitemRef, onSelectItem, }) => {
    if (items.length) {
        return (react_1.default.createElement(react_1.default.Fragment, null, items.map((item, index) => (react_1.default.createElement("li", { key: `${item.value}-${item.label}`, className: "c-select__item", "aria-selected": value === item.value, "aria-label": item.value, role: "option", ref: (el) => (listitemRef.current[index] = el), value: item.value, tabIndex: 0, onMouseDown: (e) => e.preventDefault(), onClick: () => onSelectItem(item) },
            react_1.default.createElement("div", { className: "c-option" },
                react_1.default.createElement("div", { className: "c-option__description d-flex " },
                    react_1.default.createElement("table", null,
                        react_1.default.createElement("tbody", null,
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", { className: "flag-column d-flex", colSpan: 2 },
                                    react_1.default.createElement("img", { className: "flag", src: item.flag, alt: "11" }),
                                    react_1.default.createElement("div", { className: "c-option__value" }, item.value)),
                                react_1.default.createElement("td", null, item.label)))))))))));
    }
    return (react_1.default.createElement("li", { className: "c-select__item" },
        react_1.default.createElement("div", { className: "c-option" },
            react_1.default.createElement("p", null, "Nenhuma op\u00E7\u00E3o encontrada"))));
};
exports.ListCountriesDDI = ListCountriesDDI;
//# sourceMappingURL=ListCountriesDDI.js.map